import { render } from "./outbc.vue?vue&type=template&id=5c87d800&scoped=true"
import script from "./outbc.vue?vue&type=script&lang=js"
export * from "./outbc.vue?vue&type=script&lang=js"

import "./outbc.vue?vue&type=style&index=0&id=5c87d800&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c87d800"]])

export default __exports__